// extracted by mini-css-extract-plugin
module.exports = {"eventDate":"card-module--eventDate--2hPrH","eventName":"card-module--eventName--2ksh_","eventImage":"card-module--eventImage--28prx"};